import { Paper, Timeline, Title, Text } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import classes from "../../styles/timeline.module.css";

const NextStepsPaper = () => {
  return (
    <Paper p={"xl"} radius={"lg"} mb={"xl"}>
      <Title
        order={2}
        size="h4"
        mb={"1rem"}
        ff={"var(--wallet-font-family-sambla-sans)"}
      >
        <FormattedMessage
          id="customerSummary.nextStepsCard.title"
          defaultMessage="What happens now?"
        />
      </Title>
      {import.meta.env.VITE_BOOK_MEETING_ENABLED ? (
        <Timeline
          className={classes.timeline}
          active={4}
          bulletSize={28}
          color={"var(--wallet-color-masterbrand-brand-green)"}
        >
          <Timeline.Item bullet={1}>
            <Title order={3} size="h5">
              Rådgivningssamtal
            </Title>
            <Text c="dimmed" size="sm">
              Vi ringer upp dig för en kostnadsfritt rådgivningssamtal där vi
              analyserar och tar fram personliga råd för att förbättra din
              pension.
            </Text>
          </Timeline.Item>
          <Timeline.Item bullet={2}>
            <Title order={3} size="h5">
              Förbättra ditt sparande
            </Title>
            <Text c="dimmed" size="sm">
              För att förbättra ditt sparande kan du bland annat bli erbjuden
              att sänka dina kostnader genom att flytta dina försäkringar.
            </Text>
          </Timeline.Item>
          <Timeline.Item bullet={3}>
            <Title order={3} size="h5">
              Se din pensionsöversikt
            </Title>
            <Text c="dimmed" size="sm">
              När din rådgivning är klar kommer du att få tillgång till din
              pensionsöversikt där du kan se och följa utvecklingen av hela din
              pension. Vi finns här för dig ända fram till dagen då du går i
              pension!
            </Text>
          </Timeline.Item>
        </Timeline>
      ) : (
        <Timeline
          className={classes.timeline}
          active={4}
          bulletSize={28}
          color={"var(--wallet-color-masterbrand-brand-green)"}
        >
          <Timeline.Item bullet={1}>
            <Title order={3} size="h5">
              Analys och tidsbokning
            </Title>
            <Text c="dimmed" size="sm">
              Vi ringer upp dig för att boka ett kostnadsfritt rådgivningssamtal
              där vi analyserar och tar fram personliga råd för att förbättra
              din pension.
            </Text>
          </Timeline.Item>
          <Timeline.Item bullet={2}>
            <Title order={3} size="h5">
              Rådgivningsmöte
            </Title>
            <Text c="dimmed" size="sm">
              För att förbättra ditt sparande kan du bland annat bli erbjuden
              att sänka dina kostnader genom att flytta dina försäkringar.
            </Text>
          </Timeline.Item>
          <Timeline.Item bullet={3}>
            <Title order={3} size="h5">
              Se din pensionsöversikt
            </Title>
            <Text c="dimmed" size="sm">
              När din rådgivning är klar kommer du att få tillgång till din
              pensionsöversikt där du kan se och följa utvecklingen av hela din
              pension. Vi finns här för dig ända fram till dagen då du går i
              pension!
            </Text>
          </Timeline.Item>
        </Timeline>
      )}
    </Paper>
  );
};

export default NextStepsPaper;
